import { render, staticRenderFns } from "./pathNotFound.vue?vue&type=template&id=0b3a6788&scoped=true"
import script from "./pathNotFound.vue?vue&type=script&lang=js"
export * from "./pathNotFound.vue?vue&type=script&lang=js"
import style0 from "./pathNotFound.vue?vue&type=style&index=0&id=0b3a6788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a6788",
  null
  
)

export default component.exports